import React from 'react';

interface Props {}

const MailShare = (props: Props) => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
            <path
                d="M22 25C22.4295 25.5741 22.9774 26.0491 23.6066 26.3929C24.2357 26.7367 24.9315 26.9411 25.6467 26.9923C26.3618 27.0435 27.0796 26.9403 27.7513 26.6897C28.4231 26.4392 29.0331 26.047 29.54 25.54L32.54 22.54C33.4508 21.597 33.9548 20.3339 33.9434 19.023C33.932 17.712 33.4061 16.4579 32.4791 15.5309C31.5521 14.6038 30.298 14.078 28.987 14.0666C27.676 14.0552 26.413 14.5592 25.47 15.47L23.75 17.18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26 23.0002C25.5705 22.4261 25.0226 21.951 24.3934 21.6073C23.7642 21.2635 23.0684 21.0591 22.3533 21.0079C21.6382 20.9567 20.9204 21.0599 20.2486 21.3104C19.5769 21.561 18.9668 21.9532 18.46 22.4602L15.46 25.4602C14.5492 26.4032 14.0452 27.6662 14.0566 28.9772C14.068 30.2882 14.5938 31.5423 15.5209 32.4693C16.4479 33.3964 17.702 33.9222 19.0129 33.9336C20.3239 33.945 21.5869 33.441 22.53 32.5302L24.24 30.8202"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#EFF4FB" />
        </svg>
    );
};
export default MailShare;
